import callApi, { BaseResponse, BaseResponseDto, BaseResponsePagedDto } from "./baseRequest"

const route = 'useful-links';
export interface Link {
    id: string,
    titleBR: string,
    titleES: string,
    titleEN: string,
    descriptionBR: string,
    descriptionES: string,
    descriptionEN: string,
    link: string,
    isActive: boolean,
    usefulLinksGroupEntityId: string,
    group: Country
};

interface LinkResponse {
    links: Link[],
    success: boolean,
    error: string,
    totalItems: number,
    totalPages: number
};

export interface Country {
    id: string,
    descriptionBR: string,
    descriptionES: string,
    descriptionEN: string,
    flag:string,
    iIsActive: boolean
};

interface CountryResponse {
    countries: Country[],
    success: boolean,
    error: string
};

export function getUsefulLinks(take: number, skip: number, search: string, country: string, isActive: string, language: string):Promise<LinkResponse> {
    const result: LinkResponse = {
        links: [],
        success: false,
        error: '',
        totalItems:0,
        totalPages: 0
    };

    const response = callApi('GET', `${route}/get-all/?take=${take}&skip=${skip}&search=${search}&countryId=${country}&isActive=${isActive}&language=${language}`)
    .then(resp => {
        if (resp.data.length > 0 ?? false) {
            resp?.data.map((r: any) => {
                let link: Link = {
                    id: r.id,
                    titleBR: r.titleBR,
                    titleES: r.titleES,
                    titleEN: r.titleEN,
                    descriptionBR: r.descriptionBR,
                    descriptionES: r.descriptionES,
                    descriptionEN: r.descriptionEN,
                    link: r.link,
                    isActive: r.isActive,
                    usefulLinksGroupEntityId: r.usefulLinksGroupEntityId,
                    group: r.group
                };
                result.totalItems = resp.totalItems;
                result.totalPages = resp.totalPages;
                result.links.push(link);
            });

            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar Links';
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
}

export function createLink(titleBR: string, titleES: string, titleEN: string, descriptionBR: string,
                           descriptionES: string, descriptionEN: string, link: string, isActive: boolean,
                           usefulLinksGroupEntityId: string): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null,
    };
    const response = callApi('POST', `${route}/create`, {
        titleBR,
        titleES,
        titleEN,
        descriptionBR,
        descriptionES,
        descriptionEN,
        link,
        isActive,
        usefulLinksGroupEntityId
    }).then(response => {
            result.success = true;

            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}


export function getCountries():Promise<CountryResponse> {
    const result: CountryResponse = {
        countries: [],
        success: false,
        error: ''
    };

    const response = callApi('GET', `${route}/get-all-links-group`)
    .then(resp => {
        if (resp.data.linkGroup.length > 0 ?? false) {
            resp?.data.linkGroup.map((r: any) => {
                let country: Country = {
                    id: r.id,
                    descriptionBR: r.descriptionBR,
                    descriptionES: r.descriptionES,
                    descriptionEN: r.descriptionEN,
                    flag: r.flag,
                    iIsActive: r.iIsActive
                };

                result.countries.push(country);
            });

            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar Links';
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
}

export function getOnlyCountries():Promise<CountryResponse> {
    const result: CountryResponse = {
        countries: [],
        success: false,
        error: ''
    };

    const response = callApi('GET', `${route}/get-all-group`)
    .then(resp => {
        if (resp.data.result.length > 0 ?? false) {
            resp?.data.result.map((r: any) => {
                let country: Country = {
                    id: r.id,
                    descriptionBR: r.descriptionBR,
                    descriptionES: r.descriptionES,
                    descriptionEN: r.descriptionEN,
                    flag: r.flag,
                    iIsActive: r.isActive
                };

                result.countries.push(country);
            });

            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar Links';
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
}

export function updateLink(linkId: string, titleBR: string, titleES: string, titleEN: string, descriptionBR: string,
    descriptionES: string, descriptionEN: string, link: string, status: string,
    usefulLinksGroupEntityId: string): Promise<BaseResponseDto<any>> {
const result: BaseResponseDto<any> = {
                                        error: '',
                                        success: false,
                                        data: null,
                                        };

var isActive = JSON.parse(status);

const response = callApi('PUT', `${route}/update/${linkId}`, {
                        titleBR,
                        titleES,
                        titleEN,
                        descriptionBR,
                        descriptionES,
                        descriptionEN,
                        link,
                        isActive,
                        usefulLinksGroupEntityId
                        }).then(response => {
                        result.success = true;

                if (response.data) {
                result.success = true;
                result.data = response.data
                }
                return result;
                }).catch(err => {
                result.error = err.error;

                return result;
                });

                return response;
}